import type { DocNode } from '@atlaskit/adf-schema';
import { doc, p, link } from '@atlaskit/adf-utils/builders';
import { ErrorMessage, type ErrorMessage as ErrorMessageType } from '@atlassian/ai-agent-streaming';
import type { StreamingError } from '@atlassian/jira-issue-smart-request-summary-state/src/services/convo-ai-streaming/index-streaming.tsx';

export const GENERAL_ERROR_ADF: DocNode = doc(
	p(
		"Atlassian Intelligence can't provide a response right now. Read more ",
		link({
			href: 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/',
		})('in our support documentation.'),
	),
);
export const RATE_LIMITED_ADF: DocNode = doc(
	p(
		'Excessive use has been detected with Atlassian Intelligence. Try again later. Read more ',
		link({
			href: 'https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/',
		})('in our support documentation.'),
	),
);
export const ACCEPTABLE_USAGE_ADF: DocNode = doc(
	p('Text does not comply with Atlassian\'s "Acceptable use policy".'),
);

export const mapMessageTemplateErrorToAdfError = (
	messageTemplate: ErrorMessageType | StreamingError['message_template'],
) => {
	switch (messageTemplate) {
		case ErrorMessage.ACCEPTABLE_USE_VIOLATIONS:
			return ACCEPTABLE_USAGE_ADF;
		case ErrorMessage.RATE_LIMIT:
		case ErrorMessage.OPENAI_RATE_LIMIT_USER_ABUSE:
			return RATE_LIMITED_ADF;
		default:
			return GENERAL_ERROR_ADF;
	}
};
